export function statusName(status)
{
	const states = {
		Available: "Ledig",
		Preparing: "Forbereder",
		Charging: "Lader",
		SuspendedEVSE: "Lader pauset",
		SuspendedEV: "Pauset",
		Finishing: "Stopper",
		Reserved: "Reservert",
		Unavailable: "Utilgjengelig",
		Faulted: "Feiler"
	};

	return states[status] || status;
}
